import { render } from "./aluminuim_dash.vue?vue&type=template&id=9393e7d2&scoped=true"
import script from "./aluminuim_dash.vue?vue&type=script&lang=js"
export * from "./aluminuim_dash.vue?vue&type=script&lang=js"

import "./aluminuim_dash.vue?vue&type=style&index=0&id=9393e7d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9393e7d2"]])

export default __exports__